import {useContext} from 'react';

import {NetworkGraphContext} from '../contexts/NetworkGraphContext';

export const useNetworkGraphContext = () => useContext(NetworkGraphContext);
